import { useEffect, useRef, useState } from 'react';
import { ArrowUp } from 'lucide-react';

/** Floating "back to top" button that appears after scrolling down. */
function ScrollTop() {
  const [visible, setVisible] = useState(false);
  const visibleRef = useRef(false);

  useEffect(() => {
    let frameId = 0;
    const updateVisible = () => {
      frameId = 0;
      const nextVisible = window.scrollY > 500;
      if (visibleRef.current !== nextVisible) {
        visibleRef.current = nextVisible;
        setVisible(nextVisible);
      }
    };
    const onScroll = () => {
      if (!frameId) frameId = window.requestAnimationFrame(updateVisible);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    updateVisible();
    return () => {
      if (frameId) window.cancelAnimationFrame(frameId);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      className="scroll-top-btn"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      title="Back to top"
    >
      <ArrowUp size={20} />
    </button>
  );
}

export default ScrollTop;
